import { motion } from 'framer-motion'
import { TicketIcon, CheckCircle2 } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import type { TicketInfo } from '@/lib/supportApi'

interface TicketCardProps {
  ticket: TicketInfo
}

export function TicketCard({ ticket }: TicketCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      className="ml-9 rounded-lg border border-emerald-500/30 bg-emerald-500/5 p-4"
    >
      <div className="flex items-start gap-3">
        <div className="h-8 w-8 rounded-full bg-emerald-500/15 flex items-center justify-center shrink-0">
          <TicketIcon className="h-4 w-4 text-emerald-500" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <p className="text-sm font-medium text-foreground">
              Ticket #{ticket.number}
            </p>
            <Badge
              variant="outline"
              className="text-[10px] border-emerald-500/40 text-emerald-500 bg-emerald-500/10"
            >
              <CheckCircle2 className="h-2.5 w-2.5 mr-1" />
              Aberto
            </Badge>
          </div>
          {ticket.summary && (
            <p className="text-xs text-muted-foreground mt-1 truncate">
              {ticket.summary}
            </p>
          )}
          <p className="text-[11px] text-muted-foreground/70 mt-2">
            Um atendente entrará em contato em breve.
          </p>
        </div>
      </div>
    </motion.div>
  )
}
